function StoryTopPhotos() {
  return (
    <div className="StoryTopPhotos">
      <div className="Container">
        <div className="StoryTopPhotos__item">
          <div className="StoryTopPhotos__photo">
            <img src="/assets/story/story1.jpeg" alt="" />
          </div>
          <p className="StoryTopPhotos__caption">Climb and chill</p>
        </div>
        <div className="StoryTopPhotos__item">
          <div className="StoryTopPhotos__photo">
            <img src="/assets/story/story2.jpeg" alt="" />
          </div>
          <p className="StoryTopPhotos__caption">sandstone paradise</p>
        </div>
        <div className="StoryTopPhotos__item">
          <div className="StoryTopPhotos__photo">
            <img src="/assets/story/story3.jpeg" alt="" />
          </div>
          <p className="StoryTopPhotos__caption">&nbsp;</p>
        </div>
        <div className="StoryTopPhotos__item">
          <div className="StoryTopPhotos__photo">
            <img src="/assets/story/story4.jpeg" alt="" />
          </div>
          <p className="StoryTopPhotos__caption">Summer vibes</p>
        </div>
        <div className="StoryTopPhotos__item">
          <div className="StoryTopPhotos__photo">
            <img src="/assets/story/story5.jpeg" alt="" />
          </div>
          <p className="StoryTopPhotos__caption">Labske Piskovce</p>
        </div>
        <div className="StoryTopPhotos__item">
          <div className="StoryTopPhotos__photo">
            <img src="/assets/story/story3.jpeg" alt="" />
          </div>
          <p className="StoryTopPhotos__caption">Hang in there</p>
        </div>
        <div className="StoryTopPhotos__item">
          <div className="StoryTopPhotos__photo">
            <img src="/assets/story/story1.jpeg" alt="" />
          </div>
          <p className="StoryTopPhotos__caption">Last weekend</p>
        </div>
        <div className="StoryTopPhotos__item">
          <div className="StoryTopPhotos__photo">
            <img src="/assets/story/story2.jpeg" alt="" />
          </div>
          <p className="StoryTopPhotos__caption">sandstone paradise</p>
        </div>
      </div>
    </div>
  );
}

export default StoryTopPhotos;
